module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j0sZl"))).then(() => parcelRequire('d0iPb'));